import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Action from '../Action';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DownloadIcon from '@mui/icons-material/Download';

const GeneralDropdown: React.FC = () => {

    const { t } = useTranslation(); 
    const isMobile = useMediaQuery('(max-width:768px)');

    const colors = useAppSelector(state => state.theme.colors);
    const mouseInfo = useAppSelector(state => state.fileExplorer.mouseInfo); 
    const directory = useAppSelector(state => state.fileExplorer.directory); 

    // Adjust position calculation slightly to avoid going off-screen easily
    // This is a basic adjustment, more complex logic might be needed for perfection
    const topPosition = mouseInfo?.clientY ? Math.max(10, mouseInfo.clientY - 30) : 10;
    const leftPosition = mouseInfo?.clientX ? Math.max(10, mouseInfo.clientX - 130) : 10;

    // On mobile, maybe center it or position it differently? Sticking to cursor for now.
    const mobileTop = '50%';
    const mobileLeft = '50%';
    const mobileTransform = 'translate(-50%, -50%)';

    return ( 

        <Box
        id="general-dropdown" // Add an ID for click detection
        sx={{ 
            display: 'flex', 
            flexDirection: 'row', // Keep as row, actions are inside
            alignItems: 'center', 
            justifyContent: 'space-evenly',
            width: isMobile ? 180 : 200, // Slightly smaller on mobile
            height: 'auto',
            // Position based on mouse click, basic screen edge avoidance
            top: isMobile ? mobileTop : `${topPosition}px`, 
            left: isMobile ? mobileLeft : `${leftPosition}px`, 
            transform: isMobile ? mobileTransform : 'none',
            position: 'absolute',
            backgroundColor: colors?.fileExplorerDropdown,
            borderRadius: 2, // Slightly smaller radius
            zIndex: 1050, // Ensure it's above other elements like sidebar/navbar
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)', // Add shadow
            transition: 'width 0.2s', // Smoother transition
        }}
    >

        <Box
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', // Stack actions vertically
                alignItems: 'stretch', // Stretch actions to fill width
                width: '100%', 
                padding: 0.5, // Add slight padding
                cursor: 'pointer',
            }}
        >

            {/* Pass dropdown type for styling/behavior in Action component if needed */}
            <Action title={'newFolder'} iconColor={colors?.newFolderIcon} action={'createFolder'} type='dropdown'>
                <AddCircleOutlineIcon /> 
            </Action>

            <Action title={'uploadFile'} iconColor={colors?.uploadFileIcon} action={'uploadFile'} type='dropdown'>
                <DownloadIcon /> 
            </Action>   

            { directory?.startsWith('Patients/') && !isMobile && // Maybe hide patient info on mobile dropdown?
            <Action title={'patientInfo'} action={'patientInfo'} type='dropdown'>
                <InfoOutlinedIcon /> 
            </Action>}

        </Box>


    </Box>

    )

}; 

export default GeneralDropdown; 